import { render, staticRenderFns } from "./Capacities.vue?vue&type=template&id=c4788ec6&scoped=true&"
import script from "./Capacities.vue?vue&type=script&lang=js&"
export * from "./Capacities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4788ec6",
  null
  
)

export default component.exports